export default __webpack_public_path__ + "static/media/home.ba1f7352.svg";